import { render, staticRenderFns } from "./modalChooseEmailModels.vue?vue&type=template&id=70273588&scoped=true&"
import script from "./modalChooseEmailModels.vue?vue&type=script&lang=js&"
export * from "./modalChooseEmailModels.vue?vue&type=script&lang=js&"
import style0 from "./modalChooseEmailModels.vue?vue&type=style&index=0&id=70273588&prod&lang=scss&"
import style1 from "./modalChooseEmailModels.vue?vue&type=style&index=1&id=70273588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70273588",
  null
  
)

export default component.exports